import { Injectable } from "@angular/core";

@Injectable()
export class AgroCryptoUtil {

    public pwdEncript(pwd) {

        if (pwd == null || "" === pwd.trim()) {
            return "";
        }

        //INVERTER SENHA.
        let _reverse = pwd.split('').reverse().join('');

        //REALIZANDO CRIPTOGRAFIA INTERNA
        let sR = "";

        for (var i = 0; i < _reverse.length; i++) {
            sR = sR.concat(this.numberToStrZero((this.stringToASCII(_reverse.substring(i, i + 1)) - (8 + (i * (2 - i)))), 3));
        }

         //TRANSFORMANDO SENHA EM BASE 64.
         let _reverseBase64 = btoa(sR);

        return _reverseBase64;
    };


    private repeatString(str, len) {
        let newstr = "";
        for (var i = 0; i < len; i++) {
            newstr = newstr.concat(str);
        }
        return newstr;
    };


    private numberToStrZero(value, vallen) {
        var sRet = "";

        if (value == null) {
            return sRet;
        }

        sRet = value.toString();
        if (sRet.length != vallen) {
            sRet = this.repeatString("0", vallen - sRet.length) + sRet;
        }

        return sRet;
    };


    private stringToASCII = function (str) {
        return str.charCodeAt(0);
    };

}